import { useStores } from '@/contexts/StoreContext';

// Hook to provide undo/redo functions and state
export const useHistory = () => {
  const { historyStore } = useStores();

  const handleUndo = () => {
    historyStore.undo();
  };

  const handleRedo = () => {
    historyStore.redo();
  };

  return {
    canUndo: historyStore.undoStack.length > 0,
    canRedo: historyStore.redoStack.length > 0,
    undo: handleUndo,
    redo: handleRedo,
    historyLength: historyStore.undoStack.length,
  };
};
